const styles = {
  fira: "Fira Sans , sans-seris",
  rale: "Raleway , sans-serif",
  blue: "#0080ff"
};

export default styles;
